import { render, staticRenderFns } from "./PhotosManager.vue?vue&type=template&id=75bf1ac7&scoped=true"
import script from "./PhotosManager.vue?vue&type=script&lang=js"
export * from "./PhotosManager.vue?vue&type=script&lang=js"
import style0 from "./PhotosManager.vue?vue&type=style&index=0&id=75bf1ac7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75bf1ac7",
  null
  
)

export default component.exports